<template>
  <div class="container text-center container_bg">
    <h2 class="pt-6">承诺书签订</h2>
    <Step :arr="arr" class="mt-6 mb-6"></Step>
    <div style="width: 80%; margin: 0 auto">
      <pdf :url="url"></pdf>
    </div>
    <el-tooltip v-if="needCommitmentType.includes('ca')" class="item" effect="dark" content="请使用360浏览器切换成兼容模式，确保CA驱动安装为招采进宝平台的版本，如有疑问请咨询4006166620转3。" placement="top">
    <el-button
      type="primary"
      class="mt-3 mb-3"
      @click="goLetter"
      :loading="loading"
      >CA签订</el-button
    >
  </el-tooltip>
    <el-button v-if="needCommitmentType.includes('offline')"
      type="primary"
      class="mt-3 mb-3"
      @click="flineSignLetterCmmmit"
      :loading="loading"
      >线下签订</el-button
    >
  </div>
</template>
<script>
import Step from '../../components/CA/Step'
import pdf from '../../components/pdf/pdf'
import { submitCommitmentSign,getDockingPlatformInfoByOrderId } from '../../../src/api/comm'

export default {
  name: 'letterCmmmit.vue',
  data() {
    return {
      url: '',
      loading: false,
      needCommitmentType: '',
      arr: [
        { icon: 1, span: '保函样张确认', status: 'finish', time: '' },
        { icon: 2, span: '承诺书签订', status: 'active', time: '' },
      ],
    }
  },
  async beforeMount() {
    // 已废弃：不再从 Vuex letter.guarantee 读 formStorage（form 在此页面未被使用）
    this.url = `/zcjf/base/file/download/${this.$route.query.id}`
    const res = await getDockingPlatformInfoByOrderId(this.$route.query.orderId)
    this.needCommitmentType = res.data?.needCommitmentType || 'ca|offline'
  },
  computed: {},
  components: {
    Step,
    pdf,
  },
  methods: {
    async goLetter() {
      const { origin } = location
      this.loading = true
      let url = await submitCommitmentSign({
        orderId: this.$route.query.orderId,
        callBackUrl:
          origin + '/#/orderDetail?order=' + this.$route.query.orderId,
      })
      this.loading = false
      location.href = url.data
    },
    flineSignLetterCmmmit() {
        let data = {
              pdfID: this.$route.query.id,
              orderId: this.$route.query.orderId,
            }
            this.$router.push({
              name: 'flineSignLetterCmmmit',
              query: {
                ...data,
              },
            })

    },

  },
}
</script>
<style>
 .item {
      margin: 4px;
    }
</style>